import {Controller} from 'stimulus';

export default class extends Controller {
  connect() {
    this.element.addEventListener('change', (e) => {
      e.target.nextElementSibling.innerText = this.element.files[0].name;
    });
  }
}
